(function($) {
  $.validator.addMethod("emailfull", function(value, element) {
    return this.optional(element) || /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i.test(value);
   }, "Please enter a valid email address!");

  var countries = 'United States|Afghanistan|Albania|Algeria|Andorra|Angola|Anguilla|Antigua and Barbuda|Argentina|Armenia|Aruba|Australia|Austria|Azerbaijan|Bahamas|Bahrain|Bangladesh|Barbados|Belarus|Belgium|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnia and Herzegovina|Botswana|Brazil|British Virgin Islands|Brunei|Bulgaria|Burkina Faso|Burundi|Cambodia|Cameroon|Canada|Cape Verde|Cayman Islands|Central African Republic|Chad|Chile|China|Colombia|Comoros|Congo|Congo (DRC)|Cook Islands|Costa Rica|Côte d\'Ivoire|Croatia|Cuba|Curaçao|Cyprus|Czech Republic|Denmark|Djibouti|Dominica|Dominican Republic|East Timor|Ecuador|Egypt|El Salvador|Equatorial Guinea|Eritrea|Estonia|Ethiopia|Falkland Islands|Faroe Islands|Fiji|Finland|France|French Polynesia|Gabon|Gambia|Georgia|Germany|Ghana|Gibraltar|Greece|Greenland|Grenada|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissau|Guyana|Haiti|Honduras|Hong Kong|Hungary|Iceland|India|Indonesia|Iran|Iraq|Ireland|Israel|Italy|Jamaica|Japan|Jordan|Kazakhstan|Kenya|Kiribati|Korea|Kosovo|Kuwait|Kyrgyzstan|Laos|Latvia|Lebanon|Lesotho|Liberia|Libya|Liechtenstein|Lithuania|Luxembourg|Macau|Macedonia|Madagascar|Malawi|Malaysia|Maldives|Mali|Malta|Marshall Islands|Martinique|Mauritania|Mauritius|Mexico|Micronesia|Moldova|Monaco|Mongolia|Montenegro|Montserrat|Morocco|Mozambique|Myanmar|Namibia|Nauru|Nepal|Netherlands|New Zealand|Nicaragua|Niger|Nigeria|Norway|Oman|Pakistan|Palau|Panama|Papua New Guinea|Paraguay|Peru|Philippines|Poland|Portugal|Qatar|Romania|Russia|Rwanda|Samoa|San Marino|São Tomé and Príncipe|Saudi Arabia|Senegal|Serbia|Seychelles|Sierra Leone|Singapore|Sint Maarten|Slovakia|Slovenia|Solomon Islands|Somalia|South Africa|Spain|Sri Lanka|St. Kitts and Nevis|St. Lucia|St. Vincent and the Grenadines|Sudan|Suriname|Swaziland|Sweden|Switzerland|Syria|Taiwan|Tajikistan|Tanzania|Thailand|Togo|Tonga|Trinidad and Tobago|Tunisia|Turkey|Turkmenistan|Turks and Caicos Islands|Tuvalu|Uganda|Ukraine|United Arab Emirates|United Kingdom|Uruguay|Uzbekistan|Vanuatu|Venezuela|Vietnam|Yemen|Zambia|Zimbabwe';
  var cityStates = {};
  cityStates['United States'] = 'Alabama|Alaska|American Samoa|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Guam|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Puerto Rico|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virgin Islands|Virginia|Washington|West Virginia|Wisconsin|Wyoming';

  var isIE = function() {
    var ua = window.navigator.userAgent; //Check the userAgent property of the window.navigator object
    var msie = ua.indexOf('MSIE '); // IE 10 or older
    var trident = ua.indexOf('Trident/'); //IE 11

    return (msie > 0 || trident > 0);
  }();

  var isAdvancedUpload = function() {
    var div = document.createElement('div');
    return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
  }();
  
  var $container = $('[data-get-offer-container]');
  var $thanksContainer = $('[data-get-offer-thank-you]')
  var $forms = $('[data-offer-form]', $container);
  var $tabs = $('[data-tab]', $container);
  var $tabButtons = $('[data-tab-button]', $container);
  var validatorConfig = {
    rules: {
      'input_3_3': {
        required: true,
        emailfull: true
      },
    },
    errorClass: 'form__field-error',
    submitHandler: function(form) {
      $container.remove();
      $thanksContainer.attr('hidden', false);
      // some other code
      // maybe disabling submit button
      // then:
      // $(form).submit();
    },
    errorPlacement: function(error, element) {
      if (element.hasClass('form-choises__input')) {
        error.appendTo(element.closest('.form-choises__list'));
      } else {
        error.insertAfter(element);
      }
    }
  };

  if (isIE) {
    $('body').addClass('browser-ie');
  }

  $tabButtons.on('click', function(e) {
    e.preventDefault();
    $tabButtons.not(this).removeClass('get-offer__tab-button--active');
    $(this).addClass('get-offer__tab-button--active');
    $tabs.removeClass('get-offer__tab--active')
    .filter('[data-tab="'+$(this).data('tab-button')+'"]')
    .addClass('get-offer__tab--active');
  });
  
  $forms.each(function(index, form) {
    var $form = $(this);
    var $steps = $('[data-form-step]', $form);
    var currentStep = 1;

    $('[data-change-step]', $form).on('click', function(e) {
      e.preventDefault();
      var changeStep = parseInt($(this).data('change-step'));
      var $current = $steps.filter('[data-form-step="'+currentStep+'"]');
      var $next = $steps.filter('[data-form-step="'+(currentStep + changeStep)+'"]');
      var validStep = function() {
        return changeStep > 0 ? validateFormStep($current) : true;
      };
      
      if ($current.length && $next.length && validStep()) {
        currentStep = currentStep + changeStep;
        $current.attr('hidden', true);
        $next.attr('hidden', false);
        $('html, body').scrollTop($next.offset().top);
      } else if ($current.length) {
        $('html, body').scrollTop($current.offset().top);
      }
    });

    var validator = $form.validate(validatorConfig);
    $form.data('validator', validator);
    fileInputsInit($form);
    countryInputsInit($form);
  });

  function validateFormStep($step) {
    var valid = true;
    var $stepFields = $('input, select', $step);
    var validator = $step.closest('[data-offer-form]').data('validator');

    if ($stepFields.length) {
      $stepFields.each(function(index, field) {
        var fieldValid = validator.element(field);

        if (!fieldValid && valid) {
          valid = false;
        }
      });
    }

    return valid;
  }

  function countryInputsInit($form) {
    var $countrySelect = $('[data-country-select]', $form);
    var $regionSelect = $('[data-region-select]', $form);
    var countryOptions = '';

    $.each(countries.split('|'), function(index, value) {
      countryOptions += '<option value="'+value+'">'+value+'</option>';
    });

    $countrySelect.append(countryOptions).on('change', function() {
      var country = $(this).val();
      var regionOptions = '';

      if (!$regionSelect.length) return;
      
      if (typeof cityStates[country] !== 'undefined') {
        $.each(cityStates[country].split('|'), function(index, value) {
          regionOptions += '<option value="'+value+'">'+value+'</option>';
        });
        $regionSelect.append(regionOptions).closest('[data-region-select-container]').attr('hidden', false);
      } else {
        $regionSelect.val('').find('option').not(':first').remove();
        $regionSelect.closest('[data-region-select-container]').attr('hidden', true);
      }
    });
  }

  // TODO: Upload files to API immediately. Limit one file size
  function fileInputsInit($form) {
    var $fileInputs = $('input[type="file"]', $form);

    $fileInputs.each(function(index, input) {
      var $inputContainer = $(input).closest('[data-file-upload]');
      var $filesList = $('[data-files-list]', $inputContainer);
      var droppedFiles = [];
      var maxSize = parseInt($(input).data('max-size')) || 10;
      // Convert maxSize to bytes
      maxSize = maxSize * 1e+6;
      var maxFiles = parseInt($(input).data('max-files')) || 8;

      var changeHandler = function(files) {
        $('label.'+validatorConfig.errorClass, $inputContainer).remove();

        $.each(files, function(index, file) {
          var sizeLimitReached = (getTotalSize() + file.size) > maxSize;

          if (sizeLimitReached) {
            $('<label class="'+validatorConfig.errorClass+'">File exceeds size limit</span>').appendTo($inputContainer);
            return false;
          }

          if (droppedFiles.length === maxFiles) {
            blockInput();
            return false;
          }

          droppedFiles.push(file);
          var fileItem = $('<div class="file-upload__list-item" data-file-item/>')
          fileItem.append('<span class="">'+file.name+' ('+parseInt(file.size / 1000)+'KB)</span>');
          fileItem.append('<button type="button" class="file-upload__list-item-remove" data-file-remove></span>');
          fileItem.appendTo($filesList);

          if (droppedFiles.length === maxFiles || getTotalSize() >= maxSize) {
            blockInput();
          }
        });
      };

      var getTotalSize = function() {
        var total = 0;
        $.each(droppedFiles, function(index, file) {
          total = total + file.size;
        });

        return total;
      };

      var blockInput = function() {
        $inputContainer.addClass('is--disabled');
      }

      $filesList.on('click', '[data-file-remove]', function(e) {
        e.preventDefault();
        var $target = $(e.currentTarget).closest('[data-file-item]');
        var index = $target.index();
        droppedFiles.splice(index, 1);
        $target.remove();
      });
      
      $(input).on('change', function(e) {
        if (!$inputContainer.hasClass('is--disabled')) {
          changeHandler(input.files);
        }
      });

      if (isAdvancedUpload) {
        $inputContainer
        .addClass('has-advanced-upload')
        .on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
          e.preventDefault();
          e.stopPropagation();
        })
        .on('dragover dragenter', function() {
          if (!$inputContainer.hasClass('is--disabled')) {
            $inputContainer.addClass('is-dragover');
          }
        })
        .on('dragleave dragend drop', function() {
          if (!$inputContainer.hasClass('is--disabled')) {
            $inputContainer.removeClass('is-dragover');
          }
        })
        .on('drop', function(e) {
          if (!$inputContainer.hasClass('is--disabled')) {
            changeHandler(e.originalEvent.dataTransfer.files);
          }
        });
      }
    });
  }

})(jQuery);